import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export function startSentry(dsn: string) {
  Sentry.init({
    dsn,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.25,
    environment: process.env.VITE_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.__BUILD_REF__,
  });
}

export function setSentryContext(key: string, data: Record<string, any>) {
  Sentry.setContext(key, data);
}
